import { trigger, state, style, transition, animate } from '@angular/animations';
import { isPlatformBrowser } from '@angular/common';
import {
 Component,
 computed,
 effect,
 inject,
 Inject,
 InjectionToken,
 OnInit,
 PLATFORM_ID,
} from '@angular/core';
import { SearchBoxService } from '@shared/services/serach-box.service';
export const WINDOW = new InjectionToken<Window>('Window', {
 factory: () => window,
});

@Component({
 selector: 'iho-header',
 templateUrl: './header.component.html',
 styleUrls: ['./header.component.scss'],
 providers: [
  {
   provide: WINDOW,
   useFactory: (platformId: Object) => {
    return isPlatformBrowser(platformId) ? window : {};
   },
   deps: [PLATFORM_ID],
  },
 ],
    animations: [
        trigger('fadeAnimation', [
            state('ecolodge', style({ opacity: 1 })),
            state('hotel', style({ opacity: 1 })),
            state('special', style({ opacity: 1 })),
            transition('ecolodge <=> hotel', [style({ opacity: 0 }), animate('500ms ease-in-out')]),
            transition('ecolodge <=> special', [style({ opacity: 0 }), animate('500ms ease-in-out')]),
            transition('hotel <=> special', [style({ opacity: 0 }), animate('500ms ease-in-out')]),
        ]),
  ]
})
export class HeaderComponent implements OnInit {
 navigatorVal = true;
 csrStatus = false;
 searchBoxService = inject(SearchBoxService);
    accommodation = this.searchBoxService.accommodation;



 constructor(
  @Inject(WINDOW) private window: Window,
  @Inject(PLATFORM_ID) private platformId: Object
 ) {
  if (isPlatformBrowser(this.platformId)) {
   this.csrStatus = true;
   this.navigatorVal = !/Android|iPhone/.test(this.window.navigator.userAgent);
  }
     
  
 }

 ngOnInit(): void {
    console.log(this.accommodation());
 }
}
